import {
  ApiResponse,
  COMMON_STATUS,
  CommonParams,
  OptionDto,
  StoreDto,
  StoreParams,
  User,
} from "@/types";
import { createQueryString } from "@/utils/filterParams";
import api from "./api";

export const storeService = {
  createStore: async (
    data: StoreParams
  ): Promise<ApiResponse<{ store: StoreDto; user: any }>> => {
    try {
      const response = await api.post("/stores", data);
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },

  getStoreById: async (id: number): Promise<ApiResponse<StoreDto>> => {
    try {
      const response = await api.get(`/stores/detail/${id}`);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  getMyStore: async (): Promise<ApiResponse<StoreDto>> => {
    try {
      const response = await api.get(`/stores/my-store`);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  deleteStore: async (id: number): Promise<ApiResponse<null>> => {
    try {
      const response = await api.delete(`/stores/${id}`);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  updateStore: async (
    id: number,
    data: {
      name: string;
      address: string | "";
      group_id: number | null;
    }
  ) => {
    try {
      const response = await api.put(`/stores/${id}`, data);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  getStoresInCompany: async (
    params: CommonParams<{
      company_id: number;
      inIds?: number[];
      notInIds?: number[];
      group_id?: number;
    }>
  ): Promise<ApiResponse<OptionDto[]>> => {
    const paramsValue = {
      page: 1,
      isPagination: 0,
      limit: 100,
      orderBy: "id",
      order: "DESC",
      withDeleted: 0,
      companyId: params.company_id,
      ...params,
    };

    const paramsString = createQueryString(paramsValue);
    const response = await api.get(`/stores/simple?${paramsString}`);
    return response.data;
  },

  getMyStores: async (
    params?: CommonParams<{
      company_id?: number;
      inIds?: number[];
      notInIds?: number[];
      group_id?: number;
    }>
  ): Promise<ApiResponse<OptionDto[]>> => {
    const paramsValue = {
      page: 1,
      isPagination: 0,
      limit: 100,
      orderBy: "id",
      order: "DESC",
      withDeleted: 0,
      ...params,
    };

    const paramsString = createQueryString(paramsValue);
    const response = await api.get(`/stores/my-company/simple?${paramsString}`);
    return response.data;
  },

  getStoreSimpleAll: async (
    params: CommonParams<{ status?: COMMON_STATUS }>
  ): Promise<ApiResponse<{ key: number; label: string }[]>> => {
    const paramsValue = {
      page: 1,
      isPagination: 1,
      limit: 100,
      orderBy: "id",
      order: "DESC",
      withDeleted: 0,
      ...params,
    };
    const paramsString = createQueryString(paramsValue);
    const response = await api.get(`/stores/simple-all?${paramsString}`);
    return response.data;
  },

  updateStoreStatus: async (id: number): Promise<ApiResponse<null>> => {
    try {
      const response = await api.patch(`/stores/${id}/status`);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  moveUserToStore: async (data: {
    userId: number;
    storeId: number;
  }): Promise<ApiResponse<null>> => {
    try {
      const response = await api.post(`/stores/move`, {
        user_id: data.userId,
        store_id: data.storeId,
      });
      return response.data.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },
  getStoresMyCompany: async (
    params: CommonParams<{}>
  ): Promise<ApiResponse<OptionDto[]>> => {
    const response = await api.get(`/stores/my-company/simple`, { params });
    return response.data;
  },
  getStoreMyUsers: async (
    params: CommonParams<{}>
  ): Promise<ApiResponse<User[]>> => {
    const response = await api.get(`/stores/my-users`, { params });
    return response.data;
  },
};
